const SESSION_LAST_ACTIVITY_KEY = 'ngk_last_activity_at';

/** Keep portal sessions alive for about a week of inactivity. */
export const SESSION_INACTIVITY_TIMEOUT_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export const markSessionActivity = (): void => {
  try {
    localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, String(Date.now()));
  } catch (error) {
    // Ignore storage errors (private mode / quota)
  }
};

export const clearSessionActivity = (): void => {
  try {
    localStorage.removeItem(SESSION_LAST_ACTIVITY_KEY);
  } catch (error) {
    // Ignore storage errors
  }
};

export const getLastSessionActivity = (): number | null => {
  try {
    const value = localStorage.getItem(SESSION_LAST_ACTIVITY_KEY);
    if (!value) return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const isSessionInactive = (timeoutMs: number = SESSION_INACTIVITY_TIMEOUT_MS): boolean => {
  const lastActivity = getLastSessionActivity();
  if (!lastActivity) return false;
  return Date.now() - lastActivity > timeoutMs;
};
